const constants = {
    ESC_KEYCODE: 27
};

export default constants;


// WEBPACK FOOTER //
// ./assets/scripts/front/App/constants.js